import { useState, useEffect } from "react";

const phrases = [
  "Biotech Internship",
  "App Developer Internship",
  "Backend Developer Internship",
  "Frontend Developer Internship",
  "AI/ML Research Internship",
  "UI/UX Internship",
  "Bioinformatics Internship",
  "Full Stack Developer Internship",
  "Biomedical Research Internship",
];

const TypingText = () => {
  const [currentPhrase, setCurrentPhrase] = useState(0);
  const [currentChar, setCurrentChar] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const phrase = phrases[currentPhrase];
    const timeout = setTimeout(
      () => {
        if (!isDeleting) {
          if (currentChar < phrase.length) {
            setCurrentChar((c) => c + 1);
          } else {
            setTimeout(() => setIsDeleting(true), 1500);
          }
        } else {
          if (currentChar > 0) {
            setCurrentChar((c) => c - 1);
          } else {
            setIsDeleting(false);
            setCurrentPhrase((p) => (p + 1) % phrases.length);
          }
        }
      },
      isDeleting ? 35 : 70
    );
    return () => clearTimeout(timeout);
  }, [currentChar, isDeleting, currentPhrase]);

  return (
    <span className="inline-flex items-baseline">
      <span className="text-gradient-green font-bold">
        {phrases[currentPhrase].substring(0, currentChar)}
      </span>
      <span className="animate-typing-cursor ml-0.5 inline-block w-[3px] h-[1em] bg-accent translate-y-[2px]" />
    </span>
  );
};

export default TypingText;
